import React from 'react';

import { EntityHistoryResponseType } from 'utils/api/modules/entities/entities.types';

import HistoryRow from './HistoryRow';
import { HistoryParagraph } from './utils';

const AmendmentRow = ({ item }: { item: EntityHistoryResponseType }): React.ReactElement => {
  const { entityField, createdAt, current } = item;

  return (
    <HistoryRow item={item}>
      <HistoryParagraph key={`${entityField.uuid}-${createdAt}`}>
        Submission amended by {current as string}
      </HistoryParagraph>
    </HistoryRow>
  );
};

export default AmendmentRow;
